import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SessionStorageService {
    private filters: any;

    constructor() {}
    setItem(key: string, value: any): void {
        try {
            const stringValue = JSON.stringify(value);
            sessionStorage.setItem(key, stringValue);
        } catch (error) {
            console.error('Error saving to session storage', error);
        }
    }

    // Get an item from session storage
    getItem<T>(key: string): T | null {
        try {
            const storedValue = sessionStorage.getItem(key);
            return storedValue ? (JSON.parse(storedValue) as T) : null;
        } catch (error) {
            console.error('Error reading from session storage', error);
            return null;
        }
    }

    // Remove an item from session storage
    removeItem(key: string): void {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error('Error removing from session storage', error);
        }
    }

    // Clear all items from session storage
    clear(): void {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.error('Error clearing session storage', error);
        }
    }

    setFilters(filters: any) {
        let cleanedFilters;

        if (filters.getRawValue) {
            cleanedFilters = filters.getRawValue();
        } else {
            cleanedFilters = JSON.parse(JSON.stringify(filters, this.getCircularReplacer()));
        }

        this.filters = this.cleanEmptyValues(cleanedFilters);
        sessionStorage.setItem('productFilters', JSON.stringify(this.filters));
    }

    getFilters() {
        const savedFilters = sessionStorage.getItem('productFilters');
        if (savedFilters) {
            this.filters = JSON.parse(savedFilters);
            this.filters = this.cleanEmptyValues(this.filters);
        }
        return this.filters;
    }

    getCircularReplacer() {
        const seen = new WeakSet();
        return (key: any, value: any) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return;
                }
                seen.add(value);
            }
            return value;
        };
    }

    cleanEmptyValues(obj: any): any {
        Object?.keys(obj)?.forEach((key) => {
            const value = obj[key];

            if (
                value === null ||
                value === undefined ||
                value === '' ||
                (Array?.isArray(value) && value.length === 0)
            ) {
                delete obj[key];
            } else if (typeof value === 'object') {
                obj[key] = this.cleanEmptyValues(value);
            }
        });
        return obj;
    }
}
